import React from 'react'

import './table-row-toggle-button.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import chevronRightIcon from '../../../../commons/src/assets/icons/chevron-right.svg'

import Icon from '../../../../commons/src/components/icon'

type Props = Overwrite<
  CommonProps<'button'>,
  {
    expanded?: boolean
    onClick?: React.MouseEventHandler
  }
>

const TableRowToggleButton = ({className, expanded = false, onClick, ...props}: Props) => (
  <button
    {...props}
    type="button"
    className={cn('TableRowToggleButton', {expanded}, className)}
    onClick={onClick}
  >
    <Icon source={chevronRightIcon} />
  </button>
)

export default TableRowToggleButton
